import React, { useState, useEffect, useContext } from 'react';
import { observer } from 'mobx-react';

import * as net from "../../lib/net";
import sso from "../../sso";
import ddo from '../../ddo.js'
import Wnd_Ok from "../../lib/ui/wnd_ok";

class Pos_Depsel extends React.Component {
  constructor(props, context) {
    super(props);

    this.store = props.store;
    this.seo = props.store.seo;

    this.state = {};
    this.state.dpa = [];
    this.state.msg = {};
   }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
      //this.set_cs();
  }

    set_cs() {
        var self = this;
        //alert(JSON.stringify(sso.seo.csid));

        if(sso.seo.csid == "1000") {
            var csa = [
                //{ id:"0", typ:"0", text: "INGET CENTRALSYSTEM"},
                { id:"1", sid:"S0003201", text: "SYSTEM 1"},
                { id:"3", sid:"S0003202", text: "SYSTEM 2"},
                { id:"5", sid:"S0003203", text: "SYSTEM 3"}
            ];
            this.setState({ csa: csa });
        }
        if(sso.seo.csid == "0002") {
            var csa = [
                //{ id:"0", typ:"0", text: "INGET CENTRALSYSTEM"},
                { id:"1", sid:"S0003101", text: "TGIF KUNGSTRADGARDEN"},
                { id:"2", sid:"S0003102", text: "TGIF TABY"},
                { id:"3", sid:"S0003103", text: "TGIF MALMO"},
                { id:"4", sid:"S0003104", text: "TGIF GAMLASTAN"},
                { id:"5", sid:"S0003105", text: "TGIF UPPSALA"},
                { id:"6", sid:"S0003201", text: "FOODLE NYKOPING"},
                { id:"7", sid:"S0003202", text: "FOODLE DANDERYD"},
                { id:"8", sid:"S0003203", text: "FOODLE SICKLA"},
                { id:"9", sid:"S0003204", text: "FOODLE HUDDINGE"},
                { id:"10", sid:"S0002051", text: "HAMNMAGASINET"},
                { id:"11", sid:"S0002371", text: "OLEARYS NYKOPING"},
                { id:"12", sid:"S0002372", text: "NITELIFE NYKOPING"},
                { id:"13", sid:"S0002198", text: "DOMINOS NYKOPING"},
                { id:"14", sid:"S0002052", text: "TOVASTUGAN"},
                { id:"15", sid:"S0002053", text: "KAJPLATS"},
                { id:"16", sid:"S0002604", text: "BAR AND BURGER"},
                { id:"17", sid:"S0003401", text: "TOLV SUPERDOME"},
                { id:"18", sid:"S0002607", text: "AMICE NYKOPING"}
            ];
            this.setState({ csa: csa }, function () {
                //alert(self.state.csa);
            });
        }
        if(sso.seo.csid == "0003") {
            var csa = [
                //{ id:"0", typ:"0", text: "INGET CENTRALSYSTEM"},
                { id:"1", sid:"S0003101", text: "TGIF KUNGSTRADGARDEN"},
                { id:"2", sid:"S0003102", text: "TGIF TABY"},
                { id:"3", sid:"S0003103", text: "TGIF MALMO"},
                { id:"4", sid:"S0003104", text: "TGIF GAMLASTAN"},
                { id:"5", sid:"S0003105", text: "TGIF UPPSALA"}
              ];
            this.setState({ csa: csa }, function () {
            });
        }
   }
    pos_init() {
        var self = this;

        var pos = {};
        pos.deps = [];
        pos.vgrps = [];
        pos.plus = [];
        self.props.store.pos = pos;

        ddo.cache.deps = {};
        ddo.cache.vgrps = [];
        ddo.cache.mkods = {};

        var req = {};
        req.req = "pos.pos_fkn.pos_init";

        net.sio_req(req)
            .then(function(ret){
                //alert(JSON.stringify(ret));

                if(!self.props.store.pos) self.props.store.pos = {};
                self.props.store.pos.deps = ret.rco.deps;
                self.props.store.pos.vgrps = ret.rco.vgrps;
                if(ret.rco.depo) ddo.cache.deps = ret.rco.depo;
                if(ret.rco.vgrps) ddo.cache.vgrps = ret.rco.vgrps;
                if(ret.rco.mkods) ddo.cache.mkods = ret.rco.mkods;

                var avd = Object.keys(ddo.cache.deps).sort()[0];
                if((avd * 1) > (ddo.cache.avd * 1)) {
                    ddo.cache.avd = avd;
                }
            })
            .catch(function(e){
                var txt = JSON.stringify(e);
                //alert(JSON.stringify(txt));
            })
    }

    dlg_style() {
      var css = {};
       css.zIndex = "19999";
     //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }
    tab_style(tabid) {
      var css = {};
      css.display = "none";
      if(this.state.tabval === tabid) css.display = "block";
      return css;
    }
    row_style(row) {
      var css = {};
      if(row.avd == ddo.cache.avd) {
        css.background = "#080";
        css.color = "#fff";
      }
      return css;
    }
    wnd_close() {
		if(this.props.ctx) this.props.ctx.setState({ wnds: {} });
		if(this.props.cb) this.props.cb();
	};
    tb_style() {
        var css = {};
        css.height = window.innerHeight - 275;
        return css;
    }
    list_style() {
        var css = {};
        //css.height = (window.innerHeight * 0.7) - 175;
        css.color = "#000";
        css.padding = "0px 5px";
        css.overflow = "auto";
        return css;
    }
    cssCols (cid) {
        var css = {};
        if(this.state.cols[cid]) css.width = this.state.cols[cid].toString() + "px";
        //if(cid == "c01") alert(JSON.stringify(this.state.cols[cid]));
        return css;
    }
  syncCols (tb) {

    if (!document.getElementById(tb)) return;

    var cols = {};
    var ix = document.getElementById(tb).rows.length - 1;
    var ic = document.getElementById(tb).rows[0].cells.length;
    var ci = 0;
    while(ci < ic) {
        var cxi = ci + 1;
        var col = "c" + cxi.toString().padStart(2, "0");
        cols[col] = document.getElementById(tb).rows[ix].cells[ci].clientWidth + 1;
        ci = ci + 1;
    }
    this.setState({cols: cols });
    //alert(JSON.stringify(this.state.cols));
    //this.forceUpdate();
  };
  cs_upd() {
    var self = this;
    self.ccs();
  };
  cs_active(row) {
    var self = this;
    self.ccs_sid(row.c0sid);
  };
  cs_typ(e) {
    var self = this;
    const value = e.target.value;
    self.seo.cs = value;
  };

  ccs_sid(sid) {
    var self = this;
    var prm = {};
    prm.req = "ccs:set_unit";
    prm.sid = sid;

    net.ccs_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        self.seo.sid = sid;
        //self.setState({cca: ret.rca });
        //toastr.success("OK", "SAPI");
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }

  ccs() {
    var self = this;
    var prm = {};
    prm.req = "cs.cs_units.csa";
    prm.avd = this.state.avd;
    //prm.fplu = datum;
    //prm.tplu = datum;

    //gda.wndLoading("Hämtar");
    net.ccs_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        self.setState({csa: ret.rca });
        //toastr.success("OK", "SAPI");
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
        //gda.wndError(txt);
    });
  }
    row_sel(row) {
        var self = this;

        ddo.cache.avd = row.avd;
        ddo.cache.avdtxt = row.text;

        //var xss = JSON.stringify(sso);
        //sessionStorage.setItem("svp_sso", xss);
        //self.pos_init();
        self.wnd_close();
    }

  render() {
    if(!this.props.wnds.depsel) return "";

    var title = this.props.title;
    if(!title) title = "Titel";

	var html =
        <div className="mx_base">
        { this.props.wnds.backdrop ? <div className="mx_backdrop" /> : null }
        <div className="mx_dlg mx_40hh flex-col" style={ this.dlg_style() }>
        <div className="mx_content flex">

            <div className="flex-row" style={{color: "#000", padding:"5px",height:"35px"}}>
                    <div className="flex-col flex">
                        <div>AVD VAL</div>
                    </div>
                    <div className="flex-col" onClick={() => this.avd_upd() }  >
                        <div>UPPDATERA</div>
                    </div>
            </div>

            <div className="divider_orange"></div>

            <div className="web-row text-center" style={{color: "#000", padding:"5px",height:"35px"}}>
                AKTIV AVD: { ddo.cache.avd } / { ddo.cache.avdtxt }
            </div>

            <div className="divider_green"></div>

            <div className="web-row px-1">
              <div className="flex-col flex" style={this.list_style()}>
                {this.props.store.pos.deps.map((row, key) =>
                <div className="" style={ this.row_style(row) } onClick={() => this.row_sel(row) }>
                  <div className="">
                    <h5 className="mb-1">{ row.text }</h5>
                    <small>{ row.desc }</small>
                  </div>
                  <p className="mb-1">AVD: { row.avd }</p>
                  <small>{ row.c0typ }</small>
                </div>
            )}
            </div>
            </div>

        </div>

        <div className="mx_foot flex-row flex-space-between">
            <div className="flex-row">
            </div>
            <button className="btn btn-hw-red w250" onClick={() => this.wnd_close() } >
                STÄNG
            </button>
            <div className="flex-row">
            </div>
        </div>
      </div>
        <Wnd_Ok msg={this.state.msg} ctx={this} />
    </div>
	;
	return html;
  };
}

export default observer(Pos_Depsel);